import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';
import './estilo.css';
import PropTypes from 'prop-types';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
// Estilo do styled components
import { Container, ModalBody, ModalMenus } from './styles';

// Importando componentes
import Modal from '~/components/Modal';

export default function Table({
  columns,
  data,
  title,
  ds,
  ed,
  messages,
  st,
  dw,
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [numbers, setNumbers] = useState([]);
  const [incorporadoraNumbers, setIncorporadoraNumbers] = useState([]);

  const estilos = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: '#2a3142',
        },
        paper: {
          backgroundColor: '#2a3142',
          width: '100%',
          maxWidth: '100%',
        },
      },
      MUIDataTableHeadCell: {
        root: {
          backgroundColor: '#2a3142',
        },
      },
      MUIDataTableFilter: {
        root: {
          backgroundColor: '#2A3142',
          width: '500px',
        },
        title: {
          color: '#FFFFFF',
        },
      },
      MuiButton: {
        label: {
          color: '#FFFFFF',
        },
      },
      MuiGridList: {
        root: {
          color: '#FFFFFF',
        },
      },
      MuiInputLabel: {
        root: {
          color: '#FFFFFF',
        },
      },
    },
  });

  const options = {
    filterType: 'dropdown',
    responsive: 'scrollMaxHeight',
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 50, 100],
    rowHover: true,
    onRowClick: colData => {
      ed(colData[0]);
    },
    print: false,
    download: !!dw,
    downloadOptions: {
      filename: 'relatorio.csv',
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    selectableRows: dw ? 'multiple' : 'none',
    textLabels: {
      body: {
        noMatch: 'Desculpe, não possui nenhum dado',
        toolTip: 'Ordenar',
      },
      pagination: {
        next: 'Proxima',
        previous: 'Anterior',
        rowsPerPage: 'Dados por página:',
        displayRows: 'de',
      },
      toolbar: {
        search: 'Pesquisar',
        downloadCsv: 'Download CSV',
        print: 'Imprimir',
        viewColumns: 'Ver Colunas',
        filterTable: 'Filtrar tabela',
      },
      filter: {
        all: 'Todos',
        title: 'Filtros',
        reset: 'Resetar',
      },
      selectedRows: {
        text: 'Dado(s) selecionado',
        delete: 'Deletar',
        deleteAria: 'Deletar dados selecionados',
      },
    },
    onRowsDelete: rowsDeleted => {
      const idsToDelete = rowsDeleted.data.map(d => data[d.dataIndex].id);
      const incorporadoraId = rowsDeleted.data.map(
        d => data[d.dataIndex].incorporadora_id
      );
      // ds(idsToDelete);
      setNumbers(idsToDelete);
      setIncorporadoraNumbers(incorporadoraId);
      setIsVisible(true);

      if (st) {
        return false;
      }
      return true;
    },
  };

  function closeModal() {
    setIsVisible(false);
  }

  function handlerExecutar() {
    ds(numbers, incorporadoraNumbers);
    setIsVisible(false);
  }

  return (
    <>
      <Container>
        <MuiThemeProvider theme={estilos}>
          <MUIDataTable
            title={title}
            data={data}
            columns={columns}
            options={options}
          />
        </MuiThemeProvider>
      </Container>
      {isVisible && (
        <Modal>
          <ModalBody>
            <span>{messages}</span>
            <ModalMenus>
              <button type="button" onClick={handlerExecutar}>
                Sim
              </button>
              <button type="button" onClick={closeModal}>
                Nao
              </button>
            </ModalMenus>
          </ModalBody>
        </Modal>
      )}
    </>
  );
}

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
  ds: PropTypes.func.isRequired,
  ed: PropTypes.func.isRequired,
  st: PropTypes.bool,
  messages: PropTypes.string.isRequired,
  dw: PropTypes.bool,
};

Table.defaultProps = {
  st: false,
  dw: true,
};
